import type { ScalarBuilder } from './scalar-builder';
import { scalar } from './scalar-builder';

class ListBuilder {
  #expressions: ScalarBuilder[];

  constructor(values: Array<string | number | ScalarBuilder>) {
    this.#expressions = values.map((value) =>
      typeof value === 'string' || typeof value === 'number'
        ? scalar(value)
        : value,
    );
  }

  toJSON = () => {
    return {
      list: {
        expressions: this.#expressions,
      },
    };
  };
}

const list = (values: Array<string | number | ScalarBuilder>) =>
  new ListBuilder(values);

export type { ListBuilder };
export { list };
